import { action, observable } from 'mobx';
import { CmsServiceInterface, Partner } from 'services/cms/types';

interface PartnersStoreState {
  partners: Partner[];
}

const initialState: PartnersStoreState = {
  partners: [],
};

class PartnersStore {
  state: PartnersStoreState = observable(initialState);

  constructor(private readonly cmsService: CmsServiceInterface) {}

  initState = action((initialState: PartnersStoreState): void => {
    this.state.partners = initialState.partners;
  });

  searchPartners = action(async (): Promise<void> => {
    this.state.partners = await this.cmsService.getPartners();
  });

  get getState(): PartnersStoreState {
    return this.state;
  }
}
export default PartnersStore;
